import { Route, Routes, useLocation } from 'react-router-dom';
import { PushContent, TermsDetail } from 'pages';

const Index = () => {
  const location = useLocation();
  return (
    <Routes location={location} key={location.pathname}>
      <Route path={'/push-content/*'} element={<PushContent />} />
      <Route path={'/detail/*'} element={<TermsDetail />} />
    </Routes>
  );
};

export default Index;
